(function() {
  'use strict';

  /* global _:false, moment:false */
  angular
    .module('linshareUiUserApp')
    .constant('moment', moment)
    .constant('_', _);
})();
